export const HOST_TOKEN = "my-secret-token";